const tw = {
    ChatLayout: {
        nav_chat: "談話",
        resource: "談話資料管理",
        upload: "談話資料登録",
        template_management: "範本管理",
        history: "履歷",
        setting: "設定",
        connection: "外部連接",
        delete: "刪除",
        clear_messages: "清空",
        back: "返回",
    },
    NavBar: {
        chats: "談話一覽",
        admin: "用戶管理",
        settings: "設定",
        logout: "登出",
        saleslists: "銷售列表",
        salestemplate: "範本",
        usage: "費用明細",
        enduser_chat: "終端用戶",
    },
    EnduserChat: {
        page_title: "終端用戶聊天",
        tab_settings: "設定",
        tab_talks: "對話記錄",
        tab_usage: "使用量",
        back: "返回",
        display_settings: "顯示設定",
        is_enabled: "顯示 AI 聊天",
        source_chat: "預設參照知識庫（聊天）",
        source_chat_hint: "選單未個別指定時使用的知識庫（後備）",
        source_chat_unset: "（未選擇）",
        menu_label: "選單名稱（按鈕顯示）",
        menu_source_chat: "參照聊天",
        menu_source_chat_default: "（使用預設）",
        menu_source_chat_hint: "可為每個選單個別選擇參照的知識庫（聊天）。未選擇的選單會使用上方的「預設參照知識庫」。",
        enabled_on: "公開中",
        enabled_off: "非公開",
        enabled_hint: "關閉後將切換為休止模式（僅顯示表單導引）",
        auto_disable: "超過上限時自動關閉",
        memory_flag: "對話記憶",
        memory_flag_hint: "開啟後，AI 會參考同一對話中先前的內容來回答",
        greeting_message: "問候訊息",
        ui_texts: "固定文字（可選編輯）",
        ui_texts_hint: "可覆寫聊天畫面上固定顯示的文字。未填寫的項目將使用預設文字。",
        txt_header_title: "標題列",
        txt_menu_prompt: "選單選擇的提示文字",
        txt_composer_prompt: "輸入框的提示文字",
        txt_loading: "回覆產生中的顯示文字",
        txt_loading_hint: "等待回覆期間，會與閃爍圓點（・・・）一同顯示。未填寫時僅顯示圓點。",
        txt_no_answer: "查無資料時的文字",
        txt_no_answer_hint: "AI 找不到答案時的文字。由 AI 生成，可能會略有改寫。",
        txt_feedback_prompt: "解決確認的文字",
        txt_feedback_yes: "選擇「是」時的文字",
        txt_feedback_no: "選擇「否」時的文字",
        txt_escalate_message: "引導至表單的文字（選擇「否」時等）",
        txt_escalate_message_hint: "選擇「否」或點擊表單引導時顯示。",
        txt_escalate_link: "洽詢表單連結文字",
        txt_escalate_link_hint: "對話下方常設引導、查無資料時、休止畫面的表單連結共用此文字。",
        txt_footer_escalate_prefix: "常設表單引導的前置文字（選填）",
        txt_footer_escalate_prefix_hint: "對話下方常設顯示的表單引導連結前的文字。留空則僅顯示連結文字。",
        txt_no_answer_prompt: "表單引導的前置文字（查無資料時）",
        dormant_title: "休止模式的顯示（AI 聊天關閉時）",
        dormant_hint: "「顯示 AI 聊天」關閉時，元件所顯示的內容。未填寫時使用預設文字。",
        dormant_message: "說明文字（上方）",
        txt_disabled_message: "達到上限・停用時的回覆文字",
        txt_disabled_message_hint: "當點數達到上限或停用期間，使用者於對話中送出訊息時回覆的文字。未填寫時使用預設文字。",
        txt_limit_reached_message: "達到上限時的回覆文字（第一次）",
        txt_limit_reached_message_hint: "對話中達到硬性上限時，作為該次回覆返回的文字（避免顯示系統錯誤）。之後將自動關閉並切換為「達到上限・停用時的回覆文字」。未填寫時使用預設文字。",
        dormant_links: "連結按鈕（FAQ・條款・指南等）",
        dormant_link_label: "按鈕名稱",
        dormant_add_link: "新增連結",
        dormant_footer: "說明文字（下方・選填）",
        character_image: "角色圖片",
        character_image_hint: "建議：正方形、320×320px 以上的 PNG（將以圓形裁切顯示。為在高解析度裝置上清晰顯示，建議為顯示尺寸的 2 倍以上）",
        promo_char_image: "招攬用角色圖片（對話框旁的立繪）",
        promo_char_image_hint: "在啟動按鈕旁顯示立繪與對話框「有什麼困擾嗎？」。僅在設定此圖片時顯示，未設定則不顯示（與對話內頭像為不同圖片）。建議：背景透明的直式 PNG。使用者收合後只剩啟動按鈕。",
        character_size: "啟動按鈕的圖示尺寸",
        character_size_pc: "電腦",
        character_size_mobile: "手機",
        character_size_hint: "聊天啟動按鈕的圖示尺寸（20〜160px）。未填寫時以標準 28px 顯示。",
        character_chat_size: "聊天內圖示尺寸",
        character_chat_size_hint: "顯示於各訊息旁的圖示尺寸（20〜120px）。未填寫時以標準 30px 顯示。",
        contact_form_url: "聯絡表單 URL",
        min_message_length: "最小發送字數",
        model: "使用模型",
        widget_embed: "元件設置",
        widget_embed_show: "顯示設置資訊",
        widget_embed_hide: "隱藏設置資訊",
        widget_embed_secure_hint: "公開 API 金鑰・嵌入程式碼等設置資訊，基於安全考量預設為隱藏。僅在需要時點擊「顯示設置資訊」。",
        api_key: "公開 API 金鑰",
        copy: "複製",
        rotate_key: "重新產生",
        rotate_confirm: "要重新產生 API 金鑰嗎？舊金鑰將立即失效。",
        rotate_keyword: "重新產生",
        rotate_modal_title: "重新產生公開 API 金鑰",
        rotate_modal_warn_head: "此操作無法復原。執行後：",
        rotate_modal_warn_1: "目前的公開 API 金鑰將立即失效。",
        rotate_modal_warn_2: "所有已設置的元件將停止運作（無法回覆）。",
        rotate_modal_warn_3: "需將所有設置處的嵌入標籤更換為新金鑰。",
        rotate_modal_input_label: "如要執行，請輸入以下語句：",
        rotate_modal_cancel: "取消",
        rotate_modal_execute: "執行重新產生",
        rotate_final_confirm: "確定要重新產生嗎？舊金鑰將立即失效且無法復原。",
        allowed_origins: "允許的 Origin",
        add_origin: "新增 Origin（例：https://www.example.com）",
        embed_snippet: "嵌入程式碼",
        budget_alert: "預算警示（Slack 通知）",
        warning_threshold: "警示閾值（pt）",
        hard_limit: "硬上限（pt）",
        slack_webhook: "Slack Webhook URL",
        slack_mentions: "提及對象（Slack 使用者 ID，以逗號分隔）",
        test_slack: "測試發送",
        menu_definitions: "快速選單定義",
        add_menu: "新增選單",
        save: "儲存",
        discard: "捨棄變更",
        saved: "已儲存",
        save_failed: "儲存失敗",
        loading: "載入中...",
        filter_from: "期間（開始）",
        filter_to: "期間（結束）",
        filter_menu: "選單",
        filter_status: "狀態",
        filter_talk_id: "對話ID",
        filter_talk_id_ph: "對話ID（完整 / 部分）",
        filter_keyword: "關鍵字",
        filter_keyword_ph: "以部分一致搜尋顧客訊息",
        filter_all: "全部",
        search: "搜尋",
        unresolved: "未解決",
        resolved: "已解決",
        status_none: "未回答",
        no_data: "沒有資料",
        col_datetime: "傳送時間",
        col_talk_id: "對話ID",
        detail_internal_id: "內部ID",
        col_menu: "選單",
        col_user: "使用者",
        col_first_message: "首則訊息",
        col_count: "則數",
        col_status: "狀態",
        col_points: "消耗pt",
        usage_month_label: "對象月份",
        usage_points: "當月消耗點數（內部+外部 合計）",
        usage_hard_limit: "硬上限（內部+外部 合計）",
        usage_warning_hint: "相對於警示閾值的消耗量（內部・外部合計）",
        usage_hard_hint: "超過時自動關閉 AI 聊天（以合計值判定）",
        usage_unresolved_rate: "未解決率（當月）",
        usage_resolved_rate: "解決率（當月）",
        usage_messages: "訊息數（當月）",
    },
    EditGroupView: {
        h1: "用戶組編輯：",
        group_name: "用戶組名：",
        created_at: "創建日期和時間：",
        modified_at: "最終更新日期：",
        user_group_h4: "用戶組的用戶添加",
        username: "用戶名",
        fullname: "姓名",
        roles: "權限",
        user_group_h4_2: "可用的談話機器人添加",
        chat_title: "談話機器人名",
        submit: "更新",
        handleBack: "返回",
        edit_group_err: "用戶組信息變更失敗！",
    },
    EditUserView: {
        h1: "用戶編輯：",
        username: "用戶ID：",
        mail_address: "電子郵件地址：",
        password: "密碼：",
        show: "表示",
        not_show: "非表示",
        roles: "權限：",
        groups: "用戶組：",
        created_at: "用戶登錄日時：",
        modified_at: "最終更新日期：",
        submit: "更新",
        handleBack: "返回",
        change_password: "密碼変更",
        password_format_err: "密碼長度必須至少為 8 個字符，並包含大小寫字母、數字和特殊字符。",
        role_error: "請選擇用戶權限",
        group_error: "請選擇用戶所屬的用戶組",
    },
    NewGroupView: {
        h1: "新建用戶組",
        group_name: "用戶組名：",
        user_group_h4: "用戶組的用戶添加",
        username: "用戶名",
        fullname: "姓名",
        roles: "權限",
        user_group_h4_2: "用戶組談話機器人添加",
        chat_title: "談話機器人名",
        submit: "保存",
        handleBack: "返回",
        new_group_err: "新用戶組注冊失敗！\n請確認該用戶組是否已經被注冊。",
        registered_group: "※已注冊的用戶組，請更改用戶組名。",
    },
    NewUserView: {
        h1: "新建用戶",
        username: "用戶ID：",
        full_name: "全名：",
        mail_address: "電子郵件地址：",
        password: "密碼：",
        show: "表示",
        not_show: "非表示",
        roles: "權限：",
        groups: "用戶組：",
        submit: "注冊",
        handleBack: "返回",
        password_format_err: "密碼長度必須至少為 8 個字符，並包含大小寫字母、數字和特殊字符。",
        role_error: "請選擇用戶權限",
        group_error: "請選擇用戶所屬的用戶組",
    },
    UserListView: {
        user_h4: "用戶一覽",
        add_User: "新建用戶",
        username: "用戶名",
        fullname: "姓名",
        roles: "權限",
        groups: "用戶組",
        modified_at: "最終更新日期",
        created_at: "登錄日期",
        operation: "操作",
        edit: "編輯",
        delete: "刪除",
        group_h4: "用戶組一覽",
        add_group: "新建用戶組",
        group_name: "用戶組名",
        update_date_time: "更新日期",
        ip_h4: "IP白名單",
        ip_list: "IP",
        add_ip: "IP追加",
        modal_title: "警告",
        warning_msg_1: "刪除用戶組請注意以下事項:",
        warning_msg_2: "1.屬於該用戶組的用戶和談話將會取消與該用戶組關聯。",
        warning_msg_3: "2.如果某個談話只關聯了該用戶組，則只有擁有管理員權限的用戶才能看到或者編輯此談話",
        warning_msg_4: "要刪除嗎？",
        cancel: "取消",
        del_err: "用戶組刪除失敗！\n該用戶組不存在或已經刪除。\n請刷新畫面再試一次。",
        ip_del_err: "IP刪除失敗！",
        ip_edit_err: "請輸入正確的IP地址",
        ip_save_err: "IP保存失敗！",
        ip_edit_err2: "IP已經存在！",
        save: "保存",
    },
    AdminErrorView: {
        h1: "無訪問權限",
        error_message: "請向您的系統管理員請求訪問權限或切換到具有訪問權限的帳戶",
        back_button: "返回",
    },
    ChatResourceUploadView: {
        h1: "談話資料登録",
        resource_type: "談話資料類型",
        file: "文件",
        text: "文字",
        text_content: "文字內容",
        text_placeholder: "請輸入要登録的文字",
        resource_name: "資料名稱",
        uploadText: "登録",
        no_text: "尚未輸入文字。",
        text_registered: "已登録文字。",
        processing: "登録中...",
        choose_file: "選擇文件",
        file_name: "文件名",
        tags: "標簽",
        tags_format: "標簽1,標簽2,標簽3",
        upload: "上傳",
        page_title: "頁面標題",
        page_name: "頁名",
        uploadWebResource: "登録",
        no_files_selected: "未選擇任何文本。",
        update_ok_msg: "上傳成功。",
        update_err_msg: "上傳失敗。",
        response_ok_msg: "數據錄入成功。",
        response_err_msg: "數據錄入失敗。",
        not_pdf: "上傳的文件必須爲PDF文件",
    },
    ChatTemplateManagementView: {
        h4: "範本管理",
        search_keyword: "範本名稱關鍵字：",
        new_template: "新增範本",
        search: "篩選",
        template_name: "範本名稱",
        created_at: "建立時間",
        modified_at: "更新日期",
        operation: "操作",
        delete: "刪除",
        template_url: "範本URL",
        update_template_title: "範本上傳",
        update: "更新",
        cancel: "取消",
        warning_msg_1: "請確認",
        warning_msg_2: "即將刪除範本！",
    },
    ChatResourceView: {
        h4: "已登錄談話資料一覽",
        keyword: "關鍵詞",
        tags: "標簽",
        total_number_of_characters: "文字數合計：",
        resource_count: "談話資料数：",
        filter: "過濾",
        resource_name: "談話資料名",
        file_type: "文件形式",
        created_at: "登錄日期",
        status: "狀態",
        operation: "操作",
        edit: "編輯",
        delete: "刪除",
        status_zero: "處理等待",
        status_one: "讀取中",
        status_two: "完成",
        status_three: "錯誤",
        resource: "談話資料：",
        delete_confirm: "要刪除嗎？",
        yes: "是",
        cancel: "取消"
    },
    ChatScreenView: {
        input_msg: "請輸入信息",
        error_messages: "發生了錯誤，請稍後再試",
        close: "關閉",
        template_message: "範本問題",
        link: "外部鏈接",
        no_source_link: "無原始連結",
        reference_source: "參考資料",
        new_talk: "+ 新談話",
        his_talk: "談話記錄",
        memory_flag: "對話記憶",
        template_search: "範本檢索",
        copy: "複製",
    },
    ChatSettingView: {
        h4: "談話機器人設定",
        chat_namespace: "談話ID：",
        chat_title: "談話機器人名：",
        system_prompt: "系統提示符：",
        temperature: "回答的靈活性：",
        model: "模型",
        template_message: "範本問題：",
        add: "追加",
        del: "刪除",
        title: "標題",
        msg: "提問内容",
        must: "必填",
        group: "可查看的用戶組",
        memory: "記憶談話",
        update: "更新",
        handle_return: "返回",
        alert_max_10: "提問内容最多只能記錄10條",
        alert_not_edit: "存在沒有記入的提問内容，請記入提問内容。",
        chat_setting_err_msg: "談話機器人設定失敗。",
        chat_setting_ok_msg: "談話機器人設定成功。",
        resource_type: "談話資料類型：",
        template_name: "範本名稱：",
        resource_rag: "RAG談話資料",
        template: "範本",
        template_err: "請先上傳範本",
    },
    ChatConnectionView: {
        h4: "外部系統連接",
        messenger: "Messenger",
        messenger_service_name: "連接目標服務：",
        messenger_active_status: "有效狀態：",
        messenger_callback_url: "回呼URL：",
        messenger_verify_token: "驗證令牌：",
        messenger_facebook_page_id: "Facebook頁面ID：",
        messenger_access_token: "訪問令牌：",
        submit: "更新",
        hide_token: "隱藏",
        show_token: "顯示",
        error_messages: "發生了錯誤",
        error_messages_fbduplicate: "無法更新，因為 Facebook 專頁 ID 重複",
    },

    NewChatView: {
        h3: "談話機器人定制",
        chat_title: "談話機器人名：",
        groups: "擁有瀏覽權限的用戶組：",
        system_prompt: "系統提示符：",
        temperature: "回答的靈活性：",
        group_err: "請選擇可查看的用戶組",
        memory: "記憶談話",
        handleCreate: "注冊",
        handleReturn: "返回",
    },
    EditPasswordView: {
        h1: "密碼変更",
        old_password: "原密碼：",
        incorrect_password: "密碼不正確！",
        new_password: "新密碼：",
        new_password_confirmation: "新密碼（確認）：",
        passwords_do_not_match: "密碼不一致！",
        password_format_err: "密碼長度必須至少為 8 個字符，並包含大小寫字母、數字和特殊字符。",
        submit: "変更",
        handleBack: "返回",
    },
    SettingsView: {
        h4: "個人資料",
        username: "用戶ID：",
        full_name: "用戶顯示名：",
        mail_address: "電子郵件地址：",
        not_mail_address: "請輸入正確的郵件地址",
        otp_on: "開啓登錄時的郵件2次認證",
        otp_warning: "**注意：如要開啓登錄時的郵件2次認證，需輸入郵件地址",
        modal_title: "郵件地址認證",
        modal_body: "認證碼：",
        otp_msg: "請在下方輸入驗證碼",
        invalid_otp_code_1: "驗證碼不正確！",
        invalid_otp_code_2: "如要開啓登錄時的郵件2次認證，請輸入您的郵件地址",
        setting_ok: "設定OK!",
        send_btn: "驗證",
        close_btn: "取消",
        change_password: "密碼変更",
        update: "更新",
        handle_return: "返回",
        user_plan: "費用賬單查詢",
    },
    UserPlanView: {
        plan_detail: "每月使用情況",
        model: "模型",
        messages_total: "訊息總數",
        points_per_message: "每次使用點數",
        points_unit: "點",
        total_points: "點數總數",
        count: "總計",
        resource_detail: "資源使用量",
        element: "項目",
        resource_characters_count: "資源字數",
        user_count: "使用者數",
        chat_count: "聊天機器人數量",
        usage_amount: "使用量",
        limit: "限制",
        cost: "每月總費用",
        amount: "金額",
        total_amount: "總金額",
        csv: "匯出 CSV",
        csv_by_user: "按使用者匯出 CSV",
        handle_return: "返回",
        point_fee_table: "點數費用表",
        points_used: "使用點數",
        fee: "費用"
    },
    ChatListView: {
        h4: "談話機器人一覽",
        serach_keyword: "關鍵詞：",
        chat_count: "談話機器人数：",
        handle_create: "新建",
        handle_filter: "過濾",
        chat_title: "談話機器人名",
        author: "建立日期",
        operation: "操作",
        delete: "刪除",
        modal_title: "警告",
        warning_msg_1: "請確認",
        warning_msg_2: "即將刪除談話！",
        cancel: "取消",
    },
    ChatView: {
        enter_message: "請輸入信息！",
        file_name: "文件名",
        tags: "標簽",
        source: "【參照來源】：",
    },
    ChatEditResourceView: {
        h4: "編輯資源",
        resource_name: "談話資料名：",
        file_type: "文件形式：",
        tags: "標簽",
        description: "備考：",
        status: "狀態：",
        created_at: "登錄日期：",
        modified_at: "更新日期：",
        resource_text: "文本：",
        submit: "更新",
        backToResources: "返回",
        error_messages: "發生了錯誤",
        close: "關閉",
    },
    LoginView: {
        username: "用戶名：",
        invalid_username_or_password: "用戶名或者密碼不正確！",
        modal_title: "郵件二次認證",
        modal_body: "認證碼：",
        otp_msg: "請輸入郵件中的驗證碼",
        invalid_otp_code_1: "認證碼錯誤！",
        invalid_otp_code_2: "超過最大驗證回數！請重新登錄。",
        send_btn: "驗證",
        close_btn: "取消",
        password: "密碼：",
        submit: "登錄",
        ip_modal_title: "IP白名單錯誤",
        ip_err_1: "客戶端的IP地址不在IP白名單之内。",
        ip_err_2: "請聯係系統管理員。",
    },
    RegisterView: {
        h4: "已登錄談話資料一覽",
        search_keyword: "關鍵詞",
        tags: "標簽",
        total_number_of_characters: "文字數合計：",
        resource_count: "談話資料数：",
        filter: "過濾",
        resource_name: "談話資料名",
        file_type: "文件形式",
        created_at: "登錄日期",
        status: "狀態",
        operation: "操作",
        edit: "編輯",
        delete: "刪除",
    },
    UploadFileView: {
        upload_title: "談話資料登録",
        resource_type: "談話資料類型",
        file: "文件",
        file_upload: "選擇檔案",
        file_name: "文件名",
        tags: "標簽",
        tags_format: "標簽1,標簽2,標簽3",
        uploadFile: "上傳",
        document_title: "頁面標題",
        uploadWebResource: "登録",
    },
    TagsInput: {
        admin_del_msg: "無法刪除管理員使用者權限，因為管理員可以管理所有聊天。",
    },

    UploadServiceView: {
        // upload_title: "談話資料登録",
        resource_type: "談話資料類型",
        file: "文件",
        file_upload: "選擇檔案",
        // file_name: "文件名",
        // tags: "標簽",
        // tags_format: "標簽1,標簽2,標簽3",
        uploadFile: "上傳",
        // document_title: "頁面標題",
        uploadWebResource: "登録",
    },

    SalesListsView: {
        h4: "銷售列表",
        search_keyword: "關鍵字:",
        list_count: "列表數量:",
        handle_create: "新增",
        list_title: "列表標題",
        author: "建立時間",
        edit: "編輯",
        delete: "刪除",

        delete_confirm: "確定要刪除選中的 Sales list ?",
        OK: "確定",
        cancel: "取消"
    },

    SalesListsDetailsLayout: {
        h1: "清單標題 1",
        company_list: "公司列表",
        csv_import: "CSV導入",
        company_setting: "清單設定"
    },

    SalesListsDetailsView: {
        h4: "公司列表",
        search_keyword: "關鍵字:",
        handle_filter: "過慮",
        target_flag: "生成文字",
        target: "生成對象",
        regeneration: "在生成",
        company_information: "獲取公司資訊",
        text_generate: "文章生成",
        text_confirm: "内容確認",
        send_mail: "發電子郵件",
        data_count: "數據總件數：",

        select_all: "全選/取消全選",
        handleCreate: "+ 新增公司",
        handle_send: "大量發送",
        refresh: "更新列表",
        handle_refresh: "刷新內容",

        selected: "選擇",
        company_name: "公司名稱",
        company_url: "URL",

        crawl_status: "公司資訊取得",
        generate_status: "文章生成",
        check_status: "文章確認",
        send_status: "發送電子郵件",

        process_pending: "等待處理",
        processing: "處理中",
        finish: "完成",
        process_fail: "處理失敗",

        generate_pending: "等待生成",
        generating: "生成中",
        generate_fail: "生成失敗",

        uncheck: "未確認",
        checked: "已確認",

        send_none: "未生成",
        send_pending: "等待發送",
        send_processing: "發送中",
        send_finish: "已發送",
        send_fail: "發送失敗",
        send_delivered: "發送成功",
        send_open: "郵件已閱",
        send_click: "鏈接已點擊",

        operation: "操作",
        edit: "編輯",
        delete: "刪除",

        delete_confirm: "確定要刪除嗎?",
        OK: "確定",
        cancel: "取消",
        send_mail_modal_title: "提示",
        send_mail_modal_text: "郵件已發送",

        model_title: "編輯/確認公司",
        model_company_name: "公司名稱：",
        model_company_url: "URL:",
        model_email: "電子郵件地址：：",
        model_company_detail: "概要：",
        model_mail_text: "文章：",
        model_check_status: "確認：",
        model_update: "更新",
    },

    NewSalesListsDetailsView: {
        h3: "編輯/確認公司",

        company_name: "公司名稱：",
        company_url: "URL:",
        email: "電子郵件地址：",
        company_detail: "概要：",
        mail_text: "文章：",

        return: "返回",
        update: "新增",
    },

    NewSalesListsView: {
        h3: "新增銷售列表",

        resource_type: "談話資料類型",
        file: "文件",

        title_base: "基本資料",
        title_service: "服務資訊",
        title_template: "模板選擇",

        list_name: "銷售列表",
        sender_company_name: "發送公司",
        sender_name: "發送者",
        sender_mail_address: "發送者 email",
        mail_title: "郵件標題",
        to_name: "接收者",
        bcc: "密件副本",
        to_name_default: "負責人",
        file_upload: "*選擇郵件添附檔案：",
        must_pdf: "*僅可上傳PDF檔案",
        not_pdf: "上傳的檔案必須爲PDF",

        service_name: "服務名稱",
        service_detail_summary: "服務詳情",

        template_name: "模板名稱",

        additional_prompt: "提示：",
        check_modal_title: "警告",
        check_modal_close: "關閉",
        check_modal_msg: " 是必填欄位, 請輸入。",

        return: "返回",
        next: "下一步",
        finished: "完成",

        import: "透過文件/URL 輸入"
    },

    EditSalesListsView: {
        h3: "編輯銷售列表",

        resource_type: "談話資料類型",
        file: "附件檔案",

        title_base: "基本資料",
        title_service: "服務資訊",
        title_template: "模板選擇",

        list_name: "銷售列表",
        sender_company_name: "發送公司",
        sender_name: "發送者",
        sender_mail_address: "發送者 email",
        mail_title: "郵件標題",
        to_name: "接收者",
        bcc: "密件副本",

        service_name: "服務名稱",
        service_detail_summary: "服務詳情",

        template_name: "模板名稱",

        additional_prompt: "提示：",
        prompt_str: "【什麼是提示？】<br>" +
            "在此專案中，您可以新增在產生電子郵件文字時要傳達給產生 AI 的限制。<br>" +
            "【具體範例】<br>" +
            "指定字元數``請在600個字元以內建立。<br>" +
            "插入會議預訂連結``請務必在文字後半部包含以下項目。<br>" +
            "「如果您有興趣，請使用下面的連結進行預訂。<br>" +
            "◆ 會議預約連結 https://～～～ *預約約1分鐘內完成。",

        check_modal_title: "警告",
        check_modal_close: "關閉",
        check_modal_msg: " 是必填欄位, 請輸入。",

        return: "返回",
        next: "下一步",
        update: "更新",

        import: "透過文件/URL 輸入",
        delete_title: "刪除",
        delete_confirm: "是否刪除附件檔案？",
        OK: "刪除",
        cancel: "取消"
    },

    SalesListsImportView: {
        h3: "CSV 導入",
        csv_drag: "拖放 CSV 檔案",
        input_directly: "或不使用CSV直接輸入",

        table_name: "欄位對應",

        field_name: "欄位名稱",
        csv_field: "CSV對應欄位",
        sample_value: "取樣值",

        company_name: "公司名稱",
        company_url: "公司網址",
        company_detail: "公司描述",
        email: "郵箱地址",
        tel: "電話",
        contact_url: "連繫網址",
        mail_text: "發送內容",

        upload_file: "導入",
    },

    sales_templates: {
        h4: "電子郵件文字範本列表",
        search_keyword: "關鍵字:",
        list_count: "列表數量:",
        filter: "過濾",
        handle_create: "新增",
        list_title: "模板標題",
        author: "建立時間",
        edit: "編輯",
        delete: "刪除",

        delete_confirm: "確定要刪除選中的 Sales template ?",
        OK: "確定",
        cancel: "取消"
    },

    sales_templates_new: {
        h3: "创建新模板",

        template_name: "模板名稱",
        template_text: "模板內容",

        new: "新增",
        cancel: "取消",

        check_modal_title: "警告",
        check_modal_close: "關閉",
        check_modal_msg: " 是必填欄位, 請輸入。",
    },

    sales_templates_edit: {
        h3: "編輯模板",

        template_name: "模板名稱",
        template_text: "模板內容",

        update: "更新",
        cancel: "取消",

        check_modal_title: "警告",
        check_modal_close: "關閉",
        check_modal_msg: " 是必填欄位, 請輸入。",
    },
    SalesUsageDetailsView: {
        usage_detail: "使用明細",
        item: "項目",
        total_number: "合計件數",
        number_of_success: "成功數",
        number_of_failures: "失敗數",
        number_of_articles_generated: "文章生成數：",
        number_of_emails_sent: "郵件發送數：",
        amount_detail: "費用明細",
        total_amount: "合計金額：",
        detail: "明細：",
        quantity: "數量",
        unit_price: "單價",
        amount: "金額",
        base_amount: "基礎月費",
        base_amount1: "基礎月費(最大",
        base_amount2: "件)",
        append_amount: "追加生成費用",
        ack_button: "返回"
    },

    OptionsErrorView: {
        h1: "無訪問權限",
        error_message: "沒有For Sales的訪問許可權。",
        back_button: "返回"
    }
}
export default tw;